module.exports = __webpack_public_path__ + "img/success_icon.559f788b.svg";